var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"u-tabbed-view"},[_c('div',{key:_vm.a,staticClass:"u-tabbed-view-tabs"},_vm._l((_vm.tabs),function(c){return _c('a',{key:c.name || c.header,class:{
                'u-tabbed-view-tab': true,
                'u-tabbed-view-tab--active': c.active
            },on:{"click":function($event){_vm.setActive(c)}}},[_vm._v(_vm._s(c.header))])})),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7462d99b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/TabbedView.vue
// module id = ol1C
// module chunks = 1